

<div class="prompt-library">
    

    <div class="promt-title">
        <div class="promt-lebel">
            <p>Welcome! What would you like to create today?</p>
        </div>

        <div class="promt-action">
            <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Submit Your Idea'" [iconSrc]="'/assets/icons/star-bulb.svg'" (onClick)="requestPrompt($event)"></app-button>

            <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Create Prompt'" [iconSrc]="'/assets/icons/Plus_button.svg'" (onClick)="createPrompt($event)" *ngIf="this.user_role === 'creator' ||  this.user_role === 'curator' || this.user_role === 'admin'"></app-button>

        </div>
    </div>

    <div style="padding: 0px 24px 0px 24px;">
        <app-promt-user></app-promt-user>
    </div>
</div>